// extracted by mini-css-extract-plugin
module.exports = {"btn":"ButtonUnderlined_btn__2ChMC","btnDisabled":"ButtonUnderlined_btnDisabled__2UXwA"};